// extracted by mini-css-extract-plugin
export default {"container":"HQ-z","modal":"IQ-z","dimensions":"JQ-z","brandName":"KQ-z","productName":"LQ-z","labelValue":"MQ-z","recipientEmail":"NQ-z","recommendedFit":"OQ-z","hiddenField":"PQ-z"};